<app-header></app-header>
<header class="slidermain menu-page text-white">
    <img src="assets/img/menu-bg.jpg" alt="news" class="w-100">
     <div class="container-fluid">
         <div class="mask-content-v-center text-left">
                   <div class="row align-items-center">
                       <div class="col-md-5 text-center">
                           <h4>{{ 'Menu.m_c1' | translate }}</h4>
                            <h2>{{ 'Menu.m_c2' | translate }}</h2>
                            <div class="divider">
                                <span class="border"></span>
                                <span class="dot-txt">{{ 'Menu.m_c3' | translate }}</span>
                                <span class="border"></span>
                            </div>
                            <h4>{{ 'Menu.m_c4' | translate }} </h4>
                             <h2>{{ 'Menu.m_c5' | translate }}</h2>
                       </div>
                           <div class="col-md-5 offset-md-2 h-100">
                           <div class="border-out my-auto text-center">
                               <h3>{{ 'Menu.m_c6' | translate }} </h3>
                               <h5>{{ 'Menu.m_c7' | translate }}</h5>
                                <!-- <a target="_blank" class="download" href="assets/menus/Sajway-Tablet-Menu.pdf">{{ 'Menu.m_c8' | translate }}</a> -->
                               <a class="order-online"[routerLink]="['/order-online']">{{ 'Menu.m_c10' | translate }}</a>
                           </div>
                       </div>
                   </div>
                </div>
     </div>
</header>
